// list for audit logs Urls 
export const AuditLogUrlsKey = 'audit-log-urls';
